var map = {
	"./arrow.png": 8254,
	"./banner1.png": 1456,
	"./banner10.png": 9637,
	"./banner11.png": 2879,
	"./banner12.png": 4993,
	"./banner13.png": 3860,
	"./banner14.png": 4215,
	"./banner15.png": 2818,
	"./banner16.png": 3076,
	"./banner17.jpg": 8985,
	"./banner18.png": 6604,
	"./banner18_2.png": 6966,
	"./banner2.png": 3315,
	"./banner3.png": 5106,
	"./banner4.png": 6842,
	"./banner5.png": 5776,
	"./banner6.png": 9027,
	"./banner7.png": 9780,
	"./banner8.png": 2304,
	"./banner9.png": 7116,
	"./blog/blog1.png": 1385,
	"./blog/blog2.png": 6174,
	"./blog/blog3.png": 2983,
	"./blog/blog4.png": 4802,
	"./blog/blog5.png": 348,
	"./blog/blog6.png": 6334,
	"./blog/blog7.png": 460,
	"./blog/blog8.png": 246,
	"./blog/token2049/1.png": 9611,
	"./blog/token2049/2.png": 5127,
	"./blog/token2049/3.png": 5040,
	"./blog/token2049/4.png": 5352,
	"./blog_page2_bg.png": 8018,
	"./blog_page_bg1.png": 7569,
	"./blog_page_bg2.png": 9814,
	"./blog_page_bg3.png": 5263,
	"./country.png": 8320,
	"./gameFi_page3_bg.png": 8853,
	"./gameFi_page5_icon1.png": 4585,
	"./gameFi_page5_icon2.png": 1884,
	"./homebg.png": 7719,
	"./icon1.png": 4947,
	"./icon2.png": 6269,
	"./icon3.png": 5094,
	"./icon4.png": 6600,
	"./inter_download.png": 8910,
	"./inter_page3_bg.png": 473,
	"./inter_page8_bg.png": 3930,
	"./inter_page8_img.png": 6728,
	"./logo.png": 2079,
	"./nft_page_bg1.png": 6896,
	"./nft_page_bg2.png": 4422,
	"./nft_page_img1.png": 1157,
	"./nft_page_img2.png": 470,
	"./nft_page_img3.png": 944,
	"./on_sale.png": 8048,
	"./page10_bg.png": 247,
	"./page10_img1.png": 8188,
	"./page10_img2.png": 3989,
	"./page10_img3.png": 5866,
	"./page11_icon1.png": 6236,
	"./page11_icon2.png": 5911,
	"./page11_icon3.png": 9386,
	"./page11_icon4.png": 9174,
	"./page11_icon5.png": 7035,
	"./page12_img1.png": 8797,
	"./page12_img1bg.png": 2143,
	"./page12_img2.png": 7282,
	"./page13_bg1.png": 148,
	"./page13_bg2.png": 7420,
	"./page14_img1.png": 4537,
	"./page14_img2.png": 1198,
	"./page15_bg.png": 7135,
	"./page15_icon.png": 9410,
	"./page17_10m.png": 1019,
	"./page17_2m.png": 7680,
	"./page17_bg.png": 529,
	"./page17_bg1.png": 425,
	"./page17_bg2.png": 1442,
	"./page17_team_img1.png": 1919,
	"./page17_team_img2.png": 6419,
	"./page17_team_img3.png": 3474,
	"./page17_team_img4.png": 7665,
	"./page17_team_img5.png": 3314,
	"./page17_team_img6.png": 9417,
	"./page17_team_img7.png": 4890,
	"./page17_team_img8.png": 9137,
	"./page17_team_img9.png": 822,
	"./page18_lanch_cont15img1.png": 2979,
	"./page18_lanch_cont15img10.jpg": 3991,
	"./page18_lanch_cont15img11.jpg": 6394,
	"./page18_lanch_cont15img12.jpg": 4787,
	"./page18_lanch_cont15img13.png": 1977,
	"./page18_lanch_cont15img14.png": 1200,
	"./page18_lanch_cont15img15.png": 7870,
	"./page18_lanch_cont15img16.png": 9496,
	"./page18_lanch_cont15img17.png": 7062,
	"./page18_lanch_cont15img18.png": 9837,
	"./page18_lanch_cont15img19.png": 6476,
	"./page18_lanch_cont15img2.png": 6405,
	"./page18_lanch_cont15img20.png": 1973,
	"./page18_lanch_cont15img21.jpg": 6976,
	"./page18_lanch_cont15img22.jpg": 2876,
	"./page18_lanch_cont15img23.jpg": 2378,
	"./page18_lanch_cont15img24.jpg": 4935,
	"./page18_lanch_cont15img25.jpg": 9585,
	"./page18_lanch_cont15img26.jpg": 2183,
	"./page18_lanch_cont15img27.jpg": 6872,
	"./page18_lanch_cont15img28.jpg": 7396,
	"./page18_lanch_cont15img29.jpg": 578,
	"./page18_lanch_cont15img3.png": 5648,
	"./page18_lanch_cont15img30.jpg": 8441,
	"./page18_lanch_cont15img31.jpg": 4860,
	"./page18_lanch_cont15img32.jpg": 1576,
	"./page18_lanch_cont15img4.png": 1634,
	"./page18_lanch_cont15img5.png": 4694,
	"./page18_lanch_cont15img6.png": 8762,
	"./page18_lanch_cont15img7.png": 5861,
	"./page18_lanch_cont15img8.png": 4638,
	"./page18_lanch_cont15img9.png": 2178,
	"./page3_bg1.png": 4127,
	"./page3_bg2.png": 3083,
	"./page5_arrow.png": 6301,
	"./page5_bg.png": 3871,
	"./page5_img.png": 2069,
	"./page6_bg.png": 7615,
	"./page6_img1.png": 2196,
	"./page6_img2.png": 7578,
	"./page6_img3.png": 1874,
	"./page6_link.png": 3109,
	"./page7_img1.png": 2659,
	"./page8_icon.png": 1416,
	"./sold_out.png": 1555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3616;